import { CadranGlyph } from '../../components/CadranGlyph.js';
import type { OnboardingState } from './state.js';

interface Props {
  state: OnboardingState;
  onRestart: () => void;
}

const PLAN_LABELS: Record<OnboardingState['plan'], string> = {
  tablette: 'Tablette seule',
  famille: 'Famille',
  presence: 'Présence plus',
};

export function SuccessScreen({ state, onRestart }: Props) {
  const email = localStorage.getItem('cadran.email') ?? '';
  const isPresence = state.plan === 'presence';
  const validProches = state.proches.filter((p) => p.prenom && p.contact);

  const recap = [
    { label: 'Foyer', value: state.foyerNom || '—' },
    { label: 'Formule', value: PLAN_LABELS[state.plan] },
    {
      label: 'Invitations envoyées',
      value: validProches.length > 0 ? `${validProches.length} proche(s)` : "Aucune pour l'instant",
    },
    { label: 'Livraison estimée', value: '5 à 7 jours ouvrés' },
    ...(isPresence ? [{ label: 'SIM 4G', value: 'Incluse et préconfigurée' }] : []),
  ];

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: '48px 24px',
        background: 'var(--paper)',
      }}
    >
      <div className="card" style={{ maxWidth: '560px', width: '100%', textAlign: 'center' }}>
        <div style={{ display: 'grid', placeItems: 'center', marginBottom: '28px' }}>
          <CadranGlyph size={56} variant="fill" accent="var(--terracotta)" />
        </div>

        <div className="eyebrow" style={{ marginBottom: '12px', color: 'var(--moss)' }}>
          Commande confirmée ✓
        </div>
        <h1 className="display" style={{ fontSize: 'clamp(36px, 4vw, 52px)', margin: '0 0 16px' }}>
          C'est <em>en route</em> !
        </h1>
        <p
          style={{
            fontSize: '16px',
            color: 'var(--ink-soft)',
            lineHeight: 1.6,
            marginBottom: '32px',
          }}
        >
          La tablette est préparée pour <b>{state.foyerNom || 'votre foyer'}</b>.
          {email && (
            <>
              {' '}
              Un e-mail de confirmation a été envoyé à <b>{email}</b>.
            </>
          )}
        </p>

        <div
          style={{
            background: 'var(--paper-2)',
            borderRadius: '10px',
            padding: '20px',
            display: 'grid',
            gap: '10px',
            textAlign: 'left',
            marginBottom: '32px',
          }}
        >
          {recap.map(({ label, value }) => (
            <div
              key={label}
              style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14.5px' }}
            >
              <span style={{ color: 'var(--ink-muted)' }}>{label}</span>
              <span style={{ color: 'var(--ink)', fontWeight: 500 }}>{value}</span>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', gap: '12px', flexDirection: 'column' }}>
          <a href="/comment-ca-marche" className="btn btn-primary btn-lg">
            Préparer l'installation
          </a>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onRestart}
            style={{ fontSize: '13px' }}
          >
            Recommencer (démo)
          </button>
        </div>
      </div>
    </div>
  );
}
